module.exports = __webpack_public_path__ + "img/9788988996690.04bc4d84.jpg";